/**
 * Format a subscription plan label for charts/tables: "{Exam} - {duration} {Type}".
 */
export function formatSubscriptionPlanLabel(plan = {}) {
  const exam = String(plan.examName || plan.examTitle || '').trim();
  const dur = plan.duration != null && String(plan.duration).trim() !== ''
    ? String(plan.duration).trim()
    : '';
  const type = String(plan.subscriptionType || '').trim();

  if (exam && dur) {
    const plural = Number(dur) > 1 && type && !type.endsWith('s') ? 's' : '';
    const durationLabel = type ? `${dur} ${type}${plural}` : dur;
    return `${exam} - ${durationLabel}`;
  }

  if (exam) return exam;

  const fallback = plan.label || plan.name || plan.planName;
  return fallback ? String(fallback) : 'Unknown';
}

export function getPlanChartLabel(plan = {}) {
  return formatSubscriptionPlanLabel(plan);
}
